import main4cheer from '@/assets/main/main4/main4cheer.png'
import main4cheer1 from '@/assets/main/main4/main4cheer1.png'
import main4Phone from '@/assets/main/main4/main4phone.png'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import {
  Main4Img,
  Main4ImgWrap,
  Main4MoContent,
  Main4PcContent,
  Main4SectionWrap,
} from '@/styles/views/Main/main4'

const Main4Section = () => {
  const { width } = useWindowDimensions()

  return (
    <Main4SectionWrap>
      {width > 1200 ? (
        <Main4PcContent>
          <h3>가족과 함께 걷기!</h3>
          <p>패밀리랭킹으로 운동목표를 달성해보세요!</p>
          <Main4ImgWrap>
            <Main4Img className="left" src={main4cheer} />
            <Main4Img className="center" src={main4Phone} />
            <Main4Img className="right" src={main4cheer1} />
          </Main4ImgWrap>
        </Main4PcContent>
      ) : (
        <Main4MoContent>
          <h3>가족과 함께 걷기!</h3>
          <p>패밀리랭킹으로 운동목표를 달성해보세요!</p>
          <Main4ImgWrap>
            <Main4Img className="left" src={main4cheer} />
            <Main4Img className="center" src={main4Phone} />
            <Main4Img className="right" src={main4cheer1} />
          </Main4ImgWrap>
        </Main4MoContent>
      )}
    </Main4SectionWrap>
  )
}
export default Main4Section
